import { PLUGIN_TYPES } from '@src/constants/plugin-types';

const NUM_OF_CARDS_TYPES = [PLUGIN_TYPES?.CAROUSEL, PLUGIN_TYPES?.LIST];

export const mapPluginSubmitData = ({ values, fetchData, includeAttachments, enabledFontSize }) => {
  const type = fetchData?.type;

  const {
    // plugin level
    name,
    sortOrder,
    showVideoPeelLogo,
    // styles level
    // title
    showTitle,
    titleFont,
    titleFontSize,
    titleFontColor,
    // submission date
    showSubmissionDate,
    dateFont,
    dateFontSize,
    dateFontColor,
    // description
    showDescription,
    descriptionFont,
    descriptionFontSize,
    descriptionFontColor,
    // cards
    autoplay,
    numOfCards,
    backgroundColor,
    primaryColor,
    // border
    showBorder,
    borderRadius,
    borderWidth,
    borderColor,
    // box shadow
    showBoxShadow,
    shadowX,
    shadowY,
    shadowBlur,
    shadowSpread,
    shadowColor
  } = values;

  const titleData = {
    showTitle,
    ...(showTitle && {
      titleFont,
      ...(enabledFontSize ? { titleFontSize } : {}),
      titleFontColor
    })
  };
  const dateData = {
    showSubmissionDate,
    ...(showSubmissionDate && {
      dateFont,
      ...(enabledFontSize ? { dateFontSize } : {}),
      dateFontColor
    })
  };
  const descriptionData = {
    showDescription,
    ...(showDescription && {
      descriptionFont,
      ...(enabledFontSize ? { descriptionFontSize } : {}),
      descriptionFontColor
    })
  };
  const borderData = {
    showBorder,
    ...(showBorder && {
      borderRadius: `${borderRadius}px`,
      border: `${borderWidth}px solid ${borderColor}`
    })
  };
  const boxShadowData = {
    showBoxShadow,
    ...(showBoxShadow && {
      boxShadow: `${shadowX}px ${shadowY}px ${shadowBlur}px ${shadowSpread}px ${shadowColor}`
    })
  };

  const cardInfoData = {
    backgroundColor,
    primaryColor,
    ...(NUM_OF_CARDS_TYPES.includes(type) && {
      numOfCards
    }),
    ...(type === PLUGIN_TYPES?.PLAYLIST && {
      autoplay
    })
  };

  const data = {
    name,
    sortOrder,
    showVideoPeelLogo,
    styles: {
      ...fetchData.styles,
      ...cardInfoData,
      ...titleData,
      ...descriptionData,
      ...dateData,
      ...borderData,
      ...boxShadowData
    },
    type
  };

  const content = fetchData?.content ? fetchData?.content.map((content) => content?.id) : [];
  const pluginContent = fetchData?.content
    ? fetchData?.content.map((content) => ({ id: content?.id, contentType: content?.contentType }))
    : [];

  data[includeAttachments ? 'pluginContent' : 'content'] = includeAttachments
    ? pluginContent
    : content;

  const updateData = { pluginId: fetchData?.id, data };

  return updateData;
};



// WEBPACK FOOTER //
// ./src/vp-ui/pages/PluginPage/helpers.js